import { Component } from '@angular/core';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { AbstractDialogComponent } from '../../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';

@Component({
    selector: 'agpr-pa-create-dialog',
    templateUrl: './pa-create-dialog.component.html',
    styleUrls: ['./pa-create-dialog.component.scss'],
    standalone: false
})
export class PACreateDialogComponent extends AbstractDialogComponent {

    constructor(
        public coreDialogService: CoreDialogService
    ) {
        super(coreDialogService, 'PACreate');
    }

    createClicked() {
        window.open('https://sway.office.com/rU5TckPIznHTBQzB?ref=Link');
        this.closeDialog();
    }
}
